import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { imeiCheckRoutingModule } from './imei-check-routing.module';
import { ImeiCheckComponent } from './imei-check.component';

@NgModule({
  declarations: [ImeiCheckComponent],
  imports: [
    imeiCheckRoutingModule,
    SharedModule.forRoot(),
  ],
  exports: [ImeiCheckComponent],
  providers: [],
})
export class ImeiCheckModule { }
